import {
    ContactOrganizerButton,
    ContactOrganizerProps,
} from '@eventbrite/contact-organizer-button';
import React from 'react';
import { useEventBasicInformationContext } from '../../contexts';
import { useOrganizerBasicInfo } from '../../contexts/OrganizerContext';
import './ContactOrganizerButtonListings.scss';

export const ContactOrganizerButtonListings: React.FC<
    Pick<
        ContactOrganizerProps,
        | 'captchaKey'
        | 'isVisible'
        | 'isAuthenticated'
        | 'gaCategory'
        | 'domNodeId'
    >
> = (props) => {
    const { id: orgId, name: orgName } = useOrganizerBasicInfo();
    const { name: eventName, id: eventId } = useEventBasicInformationContext();
    return (
        <ContactOrganizerButton
            {...props}
            className={`contact-organizer-listing-page`}
            organizerId={orgId}
            organizerName={orgName}
            eventName={eventName}
            eventId={eventId}
        />
    );
};
